import {  MultiSelectTheme } from 'chakra-multiselect'

export const MultiSelectStyles = {
    components: {
        MultiSelect: MultiSelectTheme
    },
};
